export class RecomendarInmuebleModel {

    remitente: string;
    destinatario: string;
    mensaje: string;
    apellido1: string;
    apellido2: string;
    folio: string;
    nombreContacto: string;
    correoContacto: string;

    constructor() { }

}
